"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexWrap = exports.flexDirection = void 0;
var FLEX_DIRECTION_VALUES = [
    'row',
    'row-reverse',
    'column',
    'column-reverse',
];
var flexDirection = function (direction, reverse) {
    if (typeof direction !== 'string')
        return direction;
    return convertToFlexDirection(direction, reverse);
};
exports.flexDirection = flexDirection;
var convertToFlexDirection = function (direction, reverse) {
    if (FLEX_DIRECTION_VALUES.includes(direction)) {
        return direction;
    }
    switch (true) {
        default:
        case direction === 'horizontal' && !reverse:
            return 'row';
        case direction === 'horizontal' && reverse:
            return 'row-reverse';
        case direction === 'vertical' && reverse:
            return 'column-reverse';
        case direction === 'vertical' && !reverse:
            return 'column';
    }
};
var flexWrap = function (wrap) {
    if (typeof wrap !== 'boolean')
        return wrap;
    return wrap ? 'wrap' : 'nowrap';
};
exports.flexWrap = flexWrap;
//# sourceMappingURL=helpers.js.map